// removed by extract-text-webpack-plugin
module.exports = {"hidden":"LV5Oq","visuallyhidden":"_1B0tR","hide-text":"_3QpqS","center":"_2HyY0","noprint":"_1KtrD","root":"_2hXlZ","item":"_2fiCE"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-list/styles/default.scss
 ** module id = 1011
 ** module chunks = 2
 **/